
/**
 * 강의 난이도
 * @nullable
 */
export type UpdateCourseDraftRequestLevel = typeof UpdateCourseDraftRequestLevel[keyof typeof UpdateCourseDraftRequestLevel] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCourseDraftRequestLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
